import { useI18n } from '@i18n/useI18n';
import { InfoContainer } from './CardInfo.styled';
import Tooltip from '@components/Tooltips/Tooltip';
import Icon from '@assets/svg/info-circle.svg'

interface IProps {
  text: string;
  padding?: boolean;
}

export const CardInfo = (props: IProps) => {
  
  const i18n = useI18n();

  return (
    <InfoContainer padding={props.padding}>
      <Tooltip content={i18n.t(props.text)} placement='left-center'>
        <Icon />
      </Tooltip>
    </InfoContainer>
  );
};

export default CardInfo;
